var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKidsIcon = function SvgKidsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92.34,
    height: 53.943,
    viewBox: "0 0 92.34 53.943",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1625",
    "data-name": "Ret\\xE2ngulo 1625",
    width: 42.949,
    height: 53.943,
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1626",
    "data-name": "Ret\\xE2ngulo 1626",
    width: 42.03,
    height: 46.934,
    fill: "#4b4b4b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5862",
    "data-name": "Grupo 5862",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5843",
    "data-name": "Grupo 5843",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4413",
    "data-name": "Caminho 4413",
    d: "M15.159,44.119c.032-.8.041-1.66.033-2.562A14.509,14.509,0,0,0,34.95,39.714a18.4,18.4,0,0,0,3.461-6.092c1.174-.112,3.381-.955,4.3-5.534.467-2.335.255-4.066-.63-5.147a2.935,2.935,0,0,0-1.515-.982c2.109-12.661-4.9-19.227-7.428-19.2,0,0-6.02-6.072-16.944-.211a14.7,14.7,0,0,0-5.4,4.82c-1.607-.9-5.706-2.27-8.955,4.589C-2.3,20.69,5.053,38.607,5.513,43.2S0,53.766,0,53.766s14.7,2.3,15.159-9.647M40.906,27.728c-.457,2.286-1.213,3.293-1.844,3.734a30.912,30.912,0,0,0,.869-6.336c.007-.1.01-.2.017-.294.092-.357.178-.71.256-1.058a1.134,1.134,0,0,1,.452.333c.505.616.593,1.9.25,3.621M36.089,33.6c-2.5,6.342-7.4,8.8-11.994,8.8a12.11,12.11,0,0,1-8.987-3.9,15.363,15.363,0,0,1-3-4.9c-.118-.3-.229-.6-.335-.919-.1-.3-.2-.6-.286-.919a28.331,28.331,0,0,1-1.025-6.8c-.028-.367-.047-.725-.066-1.083.013-.066.027-.131.04-.2.063-.306.135-.614.216-.92s.177-.618.279-.918a6.358,6.358,0,0,1,2.175-3.276,3.375,3.375,0,0,1,.906-.442C18.2,16.843,27.1,17.819,32.1,14.259c1.55,3.962,2.871,3.5,4.824,5.57a4.669,4.669,0,0,1,.926,1.761c0,.084,0,.169,0,.254q0,.453-.014.918c-.008.3-.015.608-.029.92q-.031.649-.08,1.319a28.314,28.314,0,0,1-1.017,6.765q-.135.472-.286.919c-.106.315-.218.622-.335.919m-28.555-9.5a1.158,1.158,0,0,1,.643-.4c.021.452.046.909.081,1.374a31.172,31.172,0,0,0,.874,6.379c-.632-.44-1.39-1.446-1.848-3.736-.345-1.719-.255-3.005.25-3.621",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4414",
    "data-name": "Caminho 4414",
    d: "M24.69,37.163c.021-1.126-.364-1.815-1.1-2.023a2.277,2.277,0,0,0-1.154,0c-.736.208-1.123.9-1.1,2.023-.028,1.4.562,2.131,1.678,2.1,1.115.033,1.7-.7,1.678-2.1",
    transform: "translate(-5.628 -9.25)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4415",
    "data-name": "Caminho 4415",
    d: "M41.821,35.14a2.275,2.275,0,0,0-1.154,0c-.736.208-1.123.9-1.1,2.023-.029,1.394.56,2.131,1.676,2.1,1.115.032,1.705-.7,1.678-2.1.021-1.126-.365-1.815-1.1-2.023",
    transform: "translate(-10.438 -9.25)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4416",
    "data-name": "Caminho 4416",
    d: "M30.779,44.845l.221.112a2.794,2.794,0,0,0,2.224,0l.222-.112c.4-.2.484-.381.28-.479a1.305,1.305,0,0,0-.54-.083H31.04a1.307,1.307,0,0,0-.541.083c-.2.1-.121.276.28.479",
    transform: "translate(-8.017 -11.682)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4417",
    "data-name": "Caminho 4417",
    d: "M35.35,47.274c-.013.015-1.288,1.6-4.635,1.6-3.3,0-4.58-1.527-4.638-1.6a.551.551,0,0,0-.865.682c.063.082,1.623,2.02,5.5,2.02s5.439-1.938,5.5-2.02a.551.551,0,1,0-.868-.679",
    transform: "translate(-6.62 -12.415)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4418",
    "data-name": "Caminho 4418",
    d: "M25.762,30.261A.459.459,0,0,0,25.3,29.8H20.709a.459.459,0,0,0,0,.919H25.3a.459.459,0,0,0,.459-.459",
    transform: "translate(-5.342 -7.862)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4419",
    "data-name": "Caminho 4419",
    d: "M42.775,29.8H38.181a.459.459,0,0,0,0,.919h4.594a.459.459,0,1,0,0-.919",
    transform: "translate(-9.951 -7.862)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5845",
    "data-name": "Grupo 5845",
    transform: "translate(50.31 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4424",
    "data-name": "Caminho 4424",
    d: "M18.871,40.328c.021-1.126-.365-1.815-1.1-2.024a2.3,2.3,0,0,0-1.154,0c-.735.209-1.122.9-1.1,2.024-.027,1.4.562,2.131,1.679,2.1,1.115.033,1.705-.7,1.678-2.1",
    transform: "translate(-4.093 -10.085)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4425",
    "data-name": "Caminho 4425",
    d: "M36,38.3a2.3,2.3,0,0,0-1.154,0c-.735.209-1.123.9-1.1,2.024-.027,1.394.562,2.131,1.677,2.1,1.117.032,1.707-.7,1.678-2.1.023-1.126-.364-1.815-1.1-2.024",
    transform: "translate(-8.902 -10.085)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4426",
    "data-name": "Caminho 4426",
    d: "M24.961,48.011l.222.112a2.785,2.785,0,0,0,2.223,0l.223-.112c.4-.2.483-.381.28-.479a1.315,1.315,0,0,0-.54-.083H25.222a1.307,1.307,0,0,0-.541.083c-.2.1-.122.275.28.479",
    transform: "translate(-6.482 -12.517)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4427",
    "data-name": "Caminho 4427",
    d: "M29.535,50.436c-.053.065-1.333,1.6-4.639,1.6s-4.579-1.528-4.637-1.6a.551.551,0,0,0-.865.682c.063.082,1.625,2.02,5.5,2.02s5.44-1.938,5.5-2.02a.549.549,0,0,0-.092-.769.555.555,0,0,0-.774.086",
    transform: "translate(-5.085 -13.25)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4428",
    "data-name": "Caminho 4428",
    d: "M19.945,33.427a.459.459,0,0,0-.46-.459H14.891a.459.459,0,0,0,0,.919h4.594a.459.459,0,0,0,.46-.459",
    transform: "translate(-3.807 -8.697)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4429",
    "data-name": "Caminho 4429",
    d: "M39.78,19.123C38.858,15.969,34.763,2.311,25.3.472s-12.4,2.3-12.4,2.3S7.849,3.687,6.01,5.524C3.788,7.748.623,12.2.039,21.144a13.969,13.969,0,0,0,.955,6.422A10,10,0,0,0,1.2,30.418C2.115,35,4.324,35.841,5.5,35.952a18.369,18.369,0,0,0,3.459,6.093,14.266,14.266,0,0,0,10.856,4.89,14.264,14.264,0,0,0,10.855-4.89,18.39,18.39,0,0,0,3.461-6.093c1.174-.111,3.381-.956,4.3-5.533a10.062,10.062,0,0,0,.208-2.792c1.569-.458,3.147-1.826,3.4-5.409,0,0-1.18.563-2.25-3.095m-5,14.67a30.863,30.863,0,0,0,.858-6.134,6.826,6.826,0,0,0,1.177.164,8.527,8.527,0,0,1-.191,2.234c-.459,2.287-1.213,3.294-1.844,3.735m-2.972,2.142c-2.5,6.342-7.405,8.795-11.994,8.795s-9.49-2.449-11.989-8.795c-.118-.3-.228-.6-.336-.919q-.15-.447-.286-.92a28.476,28.476,0,0,1-1.026-6.8c-.024-.331-.04-.653-.057-.975.054-.1.113-.2.174-.306a7.187,7.187,0,0,1,.665-.919c.13-.155.267-.307.418-.455s.293-.306.431-.464a12.957,12.957,0,0,0,2.8-8.083s6.166,7.421,13.342,6.891h.394a17.21,17.21,0,0,0,1.921,1.192,15.557,15.557,0,0,0,2.064.919,14.95,14.95,0,0,0,5.042.9l0,.024.1.963c-.008.12-.013.237-.021.356A28.356,28.356,0,0,1,32.428,34.1q-.136.473-.286.92c-.107.314-.217.621-.335.919m-28.6-5.019A10.008,10.008,0,0,0,4.465,32c.11.611.237,1.21.382,1.79a4.927,4.927,0,0,1-1.642-2.879M23.57,22.771a12.115,12.115,0,0,1-5.615-7.14A22.233,22.233,0,0,0,23.52,22.36a.415.415,0,0,0,.05.412",
    transform: "translate(0 0)",
    fill: "#4b4b4b"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKidsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kids_icon.5343e34b.svg";
export { ForwardRef as ReactComponent };